import React from 'react';

import { Translate, I18n } from 'react-redux-i18n';

import { TemplatePage } from '../../../../components/common/pager';
import { TemplateHeader } from '../../../../components/template/templateHeader';
import { TemplateCheckbox } from '../../../../components/template/templateCheckbox';
import { TemplateInput } from '../../../../components/template/templateInput';
import { TemplateTextArea } from '../../../../components/template/templateTextArea';

import { paths } from '../constants/template';

import { TemplateToggle } from '../../../../components/template/templateToggle';

export const getFundraisingGuaranteeTab = (props: any) => {
  const {
    onChange,
    agreementEnabled,
    optional,
    required,
  } = props;

  return (
    <TemplatePage
      id="fundraisingGuarantee"
      path={paths.FUNDRAISING_GUARANTEE_TAB}
      i18nKey="eventPrograms.template.page.fundraising-guarantee.title"
    >
      <TemplateHeader
        as="h2"
        label="eventPrograms.template.page.fundraising-guarantee.header"
      />

      <span>
        <Translate value="eventPrograms.template.page.fundraising-guarantee.subtext" />
        &nbsp;
        <a
          isolated
          href="https://grassrootz.zendesk.com/hc/en-us/articles/13428795341327-PlaceHub-Fundraising-Guarantee"
          target="_blank"
        >
          {I18n.t("eventPrograms.template.page.fundraising-guarantee.link")}
        </a>
      </span>

      <TemplateCheckbox
        id="enableFundraisingGuarantee"
        path={paths.FUNDRAISING_GUARANTEE_ENABLED}
        inputLabel="eventPrograms.template.page.fundraising-guarantee.checkbox"
        onChange={onChange}
      />

      <TemplateToggle path={paths.FUNDRAISING_GUARANTEE_ENABLED}>
        <TemplateHeader
          as="h2"
          label="eventPrograms.template.page.fundraising-guarantee.agreement.header"
        />

        <p>
          <Translate value="eventPrograms.template.page.fundraising-guarantee.agreement.subtext" />
        </p>

        <TemplateCheckbox
          id="enableFundraisingGuaranteeAgreement"
          path={paths.FUNDRAISING_GUARANTEE_AGREEMENT_ENABLED}
          inputLabel="eventPrograms.template.page.fundraising-guarantee.agreement.checkbox"
          onChange={onChange}
        />

        <TemplateToggle path={paths.FUNDRAISING_GUARANTEE_AGREEMENT_ENABLED}>
          <TemplateInput
            id="fundraisingGuaranteeAgreementTitle"
            path={paths.FUNDRAISING_GUARANTEE_AGREEMENT_TITLE}
            label="eventPrograms.template.page.fundraising-guarantee.agreement.title.label"
            validation={agreementEnabled ? required : optional}
            onChange={onChange}
          />

          <TemplateTextArea
            id="fundraisingGuaranteeAgreementContent"
            path={paths.FUNDRAISING_GUARANTEE_AGREEMENT_CONTENT}
            label="eventPrograms.template.page.fundraising-guarantee.agreement.content.label"
            placeholder="eventPrograms.template.page.fundraising-guarantee.agreement.content.subtext"
            validation={agreementEnabled ? required : optional}
            onChange={onChange}
          />
        </TemplateToggle>
      </TemplateToggle>
    </TemplatePage>
  );
};
